import React, { useState } from "react";
import { useAuth } from "../../../context/AuthContext";
import { useProtectedRoute } from "../../../hooks/useProtectedRoute";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import PurchaseOrderForm from "../components/PurchaseOrderForm";
import { useTheme } from "@mui/material/styles";

const CreatePurchaseOrderPage: React.FC = () => {
  useProtectedRoute();
  const theme = useTheme();
  const dark = theme.palette.mode === "dark";
  const { token } = useAuth();
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (form: any) => {
    setSaving(true);
    try {
      // Backend route: POST /api/inventory/po
      const res = await api.post("/inventory/po", form, {
        headers: { Authorization: `Bearer ${token}` }
      });
      navigate(`/purchase-orders/${res.data._id}`);
    } catch (err: any) {
      alert(err.response?.data?.message || "Could not create purchase order.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto p-4">
      <h1 className="text-2xl font-bold mb-6">New Purchase Order</h1>
      <div className={`p-6 rounded shadow border ${dark ? 'bg-slate-900 border-slate-700' : 'bg-white border-slate-200'}`}>
        <PurchaseOrderForm onSubmit={handleSubmit} saving={saving} />
      </div>
    </div>
  );
};
export default CreatePurchaseOrderPage;
